class PillAnimationController {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setup());
    } else {
      this.setup();
    }
  }

  setup() {
    const pillsWrapper = document.querySelector('.hero__content-pills-wrapper');
    if (!pillsWrapper) return;

    // Create intersection observer
    const observerOptions = {
      threshold: 0.3,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.animateIn(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe the pills wrapper
    observer.observe(pillsWrapper);
  }

  animateIn(wrapper) {
    // Animate wrapper first
    wrapper.classList.add('animate-in');
    
    // Then animate pills with staggered delay
    const pills = wrapper.querySelectorAll('.hero-pill');
    
    pills.forEach((pill, index) => {
      setTimeout(() => {
        pill.classList.add('animate-in');
      }, 300 + (index * 150)); // Stagger by 150ms
    });
  }
}

// Initialize the animation controller
new PillAnimationController();